/**
 * What an address with no organisation behind it shows, in place of the whole app (#181,
 * `lib/host.js`). Deliberately no login form: signing in here leads nowhere, and that is what
 * made the case so hard to spot. Laid out like `LoginPage`, so it still reads as Verlo.
 */
const NoOrganisationPage = () => (
  <div
    className="min-h-screen bg-surface-2 flex flex-col items-center justify-center px-6 py-10"
    data-testid="no-organisation-page"
  >
    <div className="w-full max-w-xs mb-8 shrink-0">
      <img src="/verlo-logo-blue.svg" alt="Verlo" className="w-full h-auto max-h-16 object-contain" />
    </div>

    <div className="w-full max-w-sm">
      <div className="bg-white border border-hairline rounded-lg p-6">
        <h1 className="text-lg font-semibold text-ink mb-2">There&apos;s no organisation at this address</h1>
        <p className="text-[13px] text-ink-soft">
          <span className="font-medium text-ink break-all">{window.location.host}</span> isn&apos;t
          linked to an organisation in Verlo. Check the address you were given, or ask whoever
          sent it to you.
        </p>
      </div>
    </div>
  </div>
);

export default NoOrganisationPage;
